import { NavigationSite } from "./navigationSite";
import { NavigationPane } from "./navigationPane";
import { NavigationSection } from "./navigationSection";
import { NavigationDropdown } from "./navigationDropdown";
import { NavigationLivePane } from "./navigationLivePane";


export class NavigationInits {
    nav = {
        navigationSite: '.navigation-site'
    };

    constructor() {
        this.initMap();
    }

    initMap() {
        new NavigationSite(this.nav.navigationSite);
        new NavigationPane();
        new NavigationSection();
        new NavigationDropdown();
        new NavigationLivePane();
    }
}
